import { api } from "../helpers";

export const doLogin = (payload) => api("/auth/login", "POST", payload);
